/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect } from "react";
import { TextField } from "@mui/material";
import PaginationFooter from "components/pagination/pagination-footer";
import { useAsyncSearch } from "./use-async-search";
// import { useMountedState } from 'react-use'
// import { useIsMounted } from './use-is-mounted'
// import { Logger } from "cms/utils/log/logger";

const SearchFilter = (props) => {
    
    const {
        children,
        searchFunction,
        filterValue,
        autoLoad,
        needsRefresh,
        setNeedsRefresh,
        setItems,
        placeholder = "Search by title",
        instruction,
        mounted,
    } = props || {};

    const {
        term,
        page,
        pageSize,
        pages,
        loaded,
        handlePageSizeChange,
        selectPage,
        runFetchContent,
        handleSearch,
        getContent,
    } = useAsyncSearch ( mounted, filterValue, searchFunction, setItems, setNeedsRefresh );

    useEffect(() => {
        if (!loaded) {
            if (autoLoad) {
                // default search (no term)
                // To search by default uncomment the following
                if (typeof searchFunction !== "function") {
                    console.warn("searchFunction is not a Function.");
                } else {
                    // console.log(`search [term:${term}] [mounted:${mounted}]`)
                    runFetchContent(mounted);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (needsRefresh) {
            getContent(term, mounted);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needsRefresh]);

    return (
        <Fragment>
            
            {/* Instruction */}
            <div className='gallery-instruction'>
                {instruction ? instruction : "Select from existing items"}
            </div>
            
            {/* search bar */}
            <div className='gallery-searchbar-wrapper'>
                <div className='gallery-searchbar-wrapper-inner'>
                    <TextField
                        className='gallery-searchbar-input'
                        id='search_bar'
                        fullWidth
                        variant={"outlined"}
                        placeholder={placeholder}
                        value={term}
                        onChange={handleSearch.bind(this)}
                    />
                </div>
            </div>

            {/* results table */}
            <div className='gallery-search-area'>
                {children}
            </div>
            
            {/* footer pagination */}
            <div className='gallery-pagination-area'>
                {" "}
                <PaginationFooter
                    page={page}
                    pageSize={pageSize}
                    pages={pages}
                    handlePageSizeChange={handlePageSizeChange.bind(this)}
                    selectPage={selectPage.bind(this)}
                />
            </div>
        </Fragment>
    );
};

export default SearchFilter;
